import { Action} from '@ngrx/store';

export const isAuthenticated = "[Auth] set Authenticated";
export const isUnAuthenticated ="[Auth] set UnAuthenticated";
 export class isAuthenticate implements Action {
        readonly type  = isAuthenticated;    
};

export class isUnAuthenticate implements Action{
          readonly type = isUnAuthenticated ;

};


export type  authActions = isAuthenticate | isUnAuthenticate;  